var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "amapDemo",
      style: { height: _vm.windowHeight + "px", width: _vm.windowWidth + "px" },
      on: {
        contextmenu: function($event) {
          return _vm.cale()
        }
      }
    },
    [
      _c("el-amap-search-box", {
        staticClass: "search-box",
        attrs: {
          "search-option": _vm.searchOption,
          "on-search-result": _vm.onSearchResult
        }
      }),
      _vm._v(" "),
      _c(
        "el-amap",
        {
          ref: "make_map",
          staticClass: "amap-box",
          attrs: {
            vid: "make_map",
            zooms: _vm.zooms,
            center: _vm.center,
            zoom: _vm.zoom,
            events: _vm.events,
            "amap-manager": _vm.amapManager,
            plugin: _vm.plugin
          }
        },
        [
          _vm._l(_vm.poi, function(xx) {
            return _c("el-amap-text", {
              key: xx.Bounds_id,
              attrs: {
                draggable: true,
                position: xx.location.coordinates,
                text: xx.name,
                events: _vm.markerevent
              }
            })
          }),
          _vm._v(" "),
          _vm._l(_vm.poiss, function(xx) {
            return _c("el-amap-polyline", {
              key: xx.id,
              attrs: {
                vid: xx.id,
                path: xx.boundary,
                borderWeight: "2",
                strokeColor: "red"
              }
            })
          }),
          _vm._v(" "),
          _c("el-amap-polyline", {
            attrs: { path: _vm.district, borderWeight: "2", strokeColor: "red" }
          }),
          _vm._v(" "),
          _c("el-amap-polyline", {
            attrs: {
              path: _vm.cityDistrict,
              borderWeight: "2",
              strokeColor: "red"
            }
          }),
          _vm._v(" "),
          _vm._l(_vm.bounds, function(item) {
            return _c("el-amap-rectangle", {
              key: item._id,
              attrs: {
                bounds: item.bounds,
                fillOpacity: 0.5,
                fillColor: item.status == "1" ? "glay" : "blue",
                strokeWeight: 1,
                "stroke-color": "#000",
                events: _vm.recevent,
                vid: item._id
              }
            })
          }),
          _vm._v(" "),
          _vm._l(_vm.bounds_copy, function(item, index) {
            return _c("el-amap-rectangle", {
              key: JSON.stringify(item) + index,
              attrs: {
                bounds: item,
                fillOpacity: 0.5,
                fillColor: "blue",
                strokeWeight: 1,
                "stroke-color": "#000",
                events: _vm.recevent,
                vid: JSON.stringify(item) + index
              }
            })
          }),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "提示",
                visible: _vm.dialogVisible,
                width: "30%"
              },
              on: {
                "update:visible": function($event) {
                  _vm.dialogVisible = $event
                }
              }
            },
            [
              _c("span", [
                _vm._v("名字："),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.poideletetarget.name,
                      expression: "poideletetarget.name"
                    }
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.poideletetarget.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.poideletetarget, "name", $event.target.value)
                    }
                  }
                }),
                _c("br"),
                _vm._v(
                  "\n        类型：" +
                    _vm._s(
                      _vm.poideletetarget.owntype
                        ? _vm.poideletetarget.owntype
                        : _vm.poideletetarget.typecode
                    )
                )
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.dialogVisible = false
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.deleteOne()
                        }
                      }
                    },
                    [_vm._v("删除一个")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.setPopxy("deleteKind")
                        }
                      }
                    },
                    [_vm._v("删除一类")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.cancelOne()
                        }
                      }
                    },
                    [_vm._v("取消一个")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.setPopxy("cancelKind")
                        }
                      }
                    },
                    [_vm._v("取消一类")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.changeKind()
                        }
                      }
                    },
                    [_vm._v("删除此范围")]
                  ),
                  _vm._v(" "),
                  !_vm.ifDraggWrite
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.startChangeCenterPoint }
                        },
                        [_vm._v("开始更换中心点")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ifDraggWrite
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.changeCenterPoint }
                        },
                        [_vm._v("更换中心点")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.changeName }
                    },
                    [_vm._v("更改名字")]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "提示", visible: _vm.ifShowSpace, width: "30%" },
              on: {
                "update:visible": function($event) {
                  _vm.ifShowSpace = $event
                }
              }
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.ifShowSpace = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.setFinishedMOde()
                    }
                  }
                },
                [_vm._v("设置完成状态")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.cancelFinishedMOde()
                    }
                  }
                },
                [_vm._v("取消完成状态")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "提示", visible: _vm.ifsetServer, width: "30%" },
              on: {
                "update:visible": function($event) {
                  _vm.ifsetServer = $event
                }
              }
            },
            [
              _c("div", [
                _vm._v("\n        名字:" + _vm._s(_vm.information.name)),
                _c("br"),
                _vm._v(
                  "\n        类型：" + _vm._s(_vm.information.type) + "\n      "
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.information.name,
                      expression: "information.name"
                    }
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.information.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.information, "name", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.information.owntype,
                      expression: "information.owntype"
                    }
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.information.owntype },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.information, "owntype", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.ifsetServer = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.setInformation()
                    }
                  }
                },
                [_vm._v("上传")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "提示", visible: _vm.ifdeletekind, width: "30%" },
              on: {
                "update:visible": function($event) {
                  _vm.ifdeletekind = $event
                }
              }
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.ifdeletekind = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.ifdelete()
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "editor" } },
            [
              _c(
                "div",
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.amapName,
                        expression: "amapName"
                      }
                    ],
                    attrs: {
                      type: "text",
                      placeholder: "请输入城市名字,回车搜索"
                    },
                    domProps: { value: _vm.amapName },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.searchCity.apply(null, arguments)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.amapName = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: { multiple: "", placeholder: "请选择" },
                      on: {
                        change: function($event) {
                          return _vm.changedistrictList()
                        }
                      },
                      model: {
                        value: _vm.districtSelect,
                        callback: function($$v) {
                          _vm.districtSelect = $$v
                        },
                        expression: "districtSelect"
                      }
                    },
                    _vm._l(_vm.districtList, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _vm._v("需要展示的数据：" + _vm._s(_vm.lookdatanumber))
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "需要多少个数据展示范围：" + _vm._s(_vm.lookboundarynumber)
                )
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.setPolygon()
                    }
                  }
                },
                [_vm._v("上传")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { attrs: { id: "boundaryEditor" } }, [
            _c(
              "div",
              [
                _vm._v("\n        获取城市范围格子：\n        "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.amapCenterName,
                      expression: "amapCenterName"
                    }
                  ],
                  attrs: { type: "text", placeholder: "请输入城市名字" },
                  domProps: { value: _vm.amapCenterName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.amapCenterName = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.getBoundary()
                      }
                    }
                  },
                  [_vm._v("获取所有范围格子")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _vm._v("\n        获取城市区域线内格子：\n        "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.cityName,
                      expression: "cityName"
                    }
                  ],
                  attrs: {
                    type: "text",
                    placeholder: "请输入城市名字,回车搜索"
                  },
                  domProps: { value: _vm.cityName },
                  on: {
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.getArea()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.cityName = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "请选择" },
                    on: {
                      change: function($event) {
                        return _vm.getLine()
                      }
                    },
                    model: {
                      value: _vm.searchDistrictSelect,
                      callback: function($$v) {
                        _vm.searchDistrictSelect = $$v
                      },
                      expression: "searchDistrictSelect"
                    }
                  },
                  _vm._l(_vm.searchDistrictList, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value }
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.setLine()
                      }
                    }
                  },
                  [_vm._v("上传")]
                )
              ],
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f22e0b9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f22e0b9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/poiInformation.vue
// module id = null
// module chunks = 